import { Core } from "@pdftron/webviewer";
import { ERASER_COLOR } from "src/app/services/document/document-markers.service";
import { environment } from "src/environments/environment";
import { IMarkerColor } from "../interfaces";

const eraserHex = ERASER_COLOR.toHexString();

export function convertPdfColourToName(color: Core.Annotations.Color): string {
    const hexString = color.toHexString();
    if (hexString === eraserHex) {
        return 'Eraser';
    }
    const colours = environment.highlight.supportedColors as IMarkerColor[];
    const matchedColour = colours.find(c => c.hex === hexString);
    return matchedColour ? matchedColour.color : 'unknown';
}